module.exports = __webpack_public_path__ + "static/img/Logo-InterSeguros-h-White.be4642b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Logo-InterSeguros-h-White.png
// module id = UYcE
// module chunks = 0